import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import st from './AddAgeСategorieModal.module.scss'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'

const AddAgeCategorieModal = () => {
  const { modalValues: modalValue, changeValue, check } = asideModalStore

  return (
    <div className={st.fieldSet}>
      <div className={st.flex}>
        <FormField>
          <FormLabel isRequired>Age from:</FormLabel>
          <FormInput isError={check('from_age')}>
            <input
              type='number'
              placeholder={'Age from'}
              name='from_age'
              value={modalValue?.from_age || ''}
              onChange={(e) => changeValue(e.target.value, 'from_age')}
            />
          </FormInput>
        </FormField>
        <FormField>
          <FormLabel isRequired>Age before:</FormLabel>
          <FormInput isError={check('to_age')}>
            <input
              type='number'
              placeholder={'Age before'}
              name='to_age'
              value={modalValue?.to_age || ''}
              onChange={(e) => changeValue(e.target.value, 'to_age')}
            />
          </FormInput>
        </FormField>
      </div>
      <FormField>
        <FormLabel isRequired>Discipline:</FormLabel>
        <FormInput isError={check('name')}>
          <input
            type='text'
            placeholder={'Enter the name of the age group'}
            name='name'
            value={modalValue?.name || ''}
            onChange={(e) => changeValue(e.target.value, 'name')}
            maxLength={35}
          />
        </FormInput>
      </FormField>
    </div>
  )
}

export default observer(AddAgeCategorieModal)
